var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreeze({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 49,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    x: 0.5,
    y: 0.5,
    fill: "#e7ebee",
    rx: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#617889",
    stroke: "#617889",
    d: "M17.5 28c1.934 0 3.5 1.566 3.5 3.5a3.48 3.48 0 0 1-1.189 2.623A3.5 3.5 0 0 1 17.5 35a3.5 3.5 0 0 1-3.5-3.5c0-1.035.446-1.967 1.164-2.605l.146-.123.002-.002A3.5 3.5 0 0 1 17.5 28zm.25 1c-.64 0-1.185.496-1.236 1.133l-.004.117v.796l-.642.382a1.247 1.247 0 0 0-.498 1.602l.058.112.005.008c.234.385.65.6 1.067.6a1.2 1.2 0 0 0 .646-.183l.002.001 1.25-.75h-.002A1.25 1.25 0 0 0 19 31.75v-1.5c0-.686-.564-1.25-1.25-1.25z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#617889",
    d: "M27.35 16.45v3.8h-1.5v-3.8c0-.27-.24-.4-.4-.4q-.075 0-.15.03l-7.93 2.99c-.53.2-.87.7-.87 1.27v.67c-.91.68-1.5 1.77-1.5 3v-3.67c0-1.19.73-2.25 1.84-2.67l7.94-3c.22-.08.45-.12.67-.12 1 0 1.9.81 1.9 1.9M34 27v1a.5.5 0 0 1-.49.5h-1.46c-.53 0-1.01-.39-1.05-.91-.03-.31.09-.6.29-.8a.95.95 0 0 1 .7-.29h1.51c.29.01.5.23.5.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#617889",
    d: "M31.98 25.45H33c.55 0 1-.45 1-1v-.44c0-2.07-1.69-3.76-3.76-3.76H18.76c-.85 0-1.63.28-2.26.76-.91.68-1.5 1.77-1.5 3v1.78c0 .38.4.62.76.5.56-.19 1.15-.29 1.74-.29 3.03 0 5.5 2.47 5.5 5.5 0 .72-.19 1.51-.49 2.21-.16.36.09.79.48.79h7.25c2.07 0 3.76-1.69 3.76-3.76v-.19c0-.55-.45-1-1-1h-.87c-.96 0-1.88-.59-2.13-1.52-.2-.76.04-1.5.54-1.98.37-.38.88-.6 1.44-.6m-5.48-.2h-5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h5c.41 0 .75.34.75.75s-.34.75-.75.75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeze);
export default __webpack_public_path__ + "static/media/freeze.c25779e6324de5e1e6881bc2f37c42f0.svg";
export { ForwardRef as ReactComponent };